'use client';
import React, { memo } from 'react';

import { BackgroundImage, SmartLink } from '@/app/_components';
import { ROUTERS } from '@/constant';
import { useLang } from '@/hooks';
import { ICourse } from '@/services';
import { getCourses } from '@/services/Api/course.api';
import { formatTableDate2 } from '@/utils';

import useSWR from 'swr';

const ListNewBlog = () => {
	const { t } = useLang();
	const { data } = useSWR('/course', () => getCourses());

	return (
		<div className="relative py-3 mt-10 bg-white rounded-lg shadow-default">
			<div
				className={
					'bg-blue-50 border border-blue-1 py-2 px-4 rounded-default absolute top-0 left-[50%] translate-x-[-50%] translate-y-[-50%]'
				}
			>
				<p className={'text-[13px] uppercase font-bold text-blue-7'}>
					{t('tag.latest.new')}
				</p>
			</div>
			<div className={'divide-y divide-gray-2 cursor-pointer mt-6'}>
				{data?.map((item: ICourse, index: number) => {
					return (
						<SmartLink
							href={ROUTERS.COURSE_DETAIL.replace(
								'[slug]',
								item?.slug!
							)}
							key={index.toString()}
							className={'row py-3 px-4'}
						>
							<div
								className={
									'row rounded-md hover:shadow-md space-x-5 p-2 duration-300 w-full'
								}
							>
								<div
									className={
										'relative overflow-hidden rounded-lg h-[90px] aspect-square border border-gray-2/50'
									}
								>
									<BackgroundImage
										src={`${item?.mediaContents?.[0]?.url}`}
										alt={`${item?.name}`}
									/>
								</div>
								<div className={'flex-1 space-y-2'}>
									<p
										title={item?.name}
										className="text-sm font-semibold leading-tight line-clamp-2"
									>
										{item?.name}
									</p>
									<p
										className={
											'font-normal text-gray-5/70 text-[11px]'
										}
									>
										{formatTableDate2(`${item.createdAt}`)}
									</p>
									<p
										className={
											'text-blue-5 font-medium text-xs'
										}
									>
										{t('btn.detail')}
									</p>
								</div>
							</div>
						</SmartLink>
					);
				})}
			</div>
		</div>
	);
};

export default memo(ListNewBlog);
